// removed by extract-text-webpack-plugin
module.exports = {"WrapItem":"_3RpcIBEPRJnMi_XD8MLPA9","WrapSubItem":"_1jTJAg_cGRoKX1eLE04s9S","liveroom":"_3YYpV1g1CZquv2TCDjr1KX","photo":"_36gemDMDbbzS1qFNsyr3gA","text":"_3sXPxKNtVtqDQuXMbbuWUy"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/HomeRecommendModule/index.module.less
// module id = 476
// module chunks = 0